import PropTypes from 'prop-types'
import styles from './AdventureReviews.module.scss'
import { FormattedMessage } from 'react-intl'
import AdventureReviewRating from './AdventureReviewRating'
import { useState } from 'react'
import cx from 'classnames'
import AdventureFullReviewsList from './AdventureFullReviewsList'

export default function AdventureReviews({ reviews }) {
  const { userRatingCount, rating, reviews: reviewsList } = reviews
  const [showAllReviews, setShowAllReviews] = useState(false)
  return (
    <div className={cx('short-description', styles.rightSide)}>
      <div className={styles.reviewContainer}>
        <AdventureReviewRating rating={rating} />
        <FormattedMessage
          defaultMessage='{reviews, plural, =0 {No reviews} one {# Review} other {# Reviews}}'
          values={{ reviews: userRatingCount }}
        />
      </div>
      <span
        className={styles.viewAllReviews}
        onClick={() => setShowAllReviews(!showAllReviews)}
      >
        <span
          className={cx(styles.viewAllText, {
            [styles.active]: showAllReviews,
          })}
        >
          <span className={styles.underlineText}>
            <FormattedMessage defaultMessage='View Reviews' />
          </span>
        </span>
      </span>
      {showAllReviews && <AdventureFullReviewsList reviews={reviewsList} />}
    </div>
  )
}

AdventureReviews.propTypes = {
  reviews: PropTypes.object.isRequired,
}
